import { render, staticRenderFns } from "./confidentiality_badge.vue?vue&type=template&id=cd11aace"
import script from "./confidentiality_badge.vue?vue&type=script&lang=js"
export * from "./confidentiality_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports